export default {
  ongoingQuoteRequests({ page }) {
    return {
      method: 'get',
      url: 'shipper/quoteRequest/ongoing',
      params: {
        perPage: 10,
        page,
      },
    };
  },
  quoteRequest({ page, params }) {
    return {
      method: 'get',
      url: 'shipper/quoteRequest',
      params: {
        perPage: 10,
        page,
        ...params,
      },
    };
  },
  acceptQuoteResponse({ id }) {
    return {
      method: 'post',
      url: `shipper/quoteResponse/${id}/accept`,
    };
  },
  rejectQuoteResponse({ id }) {
    return {
      method: 'post',
      url: `shipper/quoteResponse/${id}/reject`,
    };
  },
  getConversations({ page }) {
    return {
      method: 'get',
      url: 'shipper/bookingConversation',
      params: {
        page,
      },
    };
  },
  getBookedRequests({ params }) {
    return {
      method: 'GET',
      url: 'shipper/quoteRequest/booked',
      params,
    };
  },
  getDefaultDeliveryAddress() {
    return {
      method: 'GET',
      url: 'shipper/delivery-address'
    };
  },
  updateDefaultDeliveryAddress(data) {
    return {
      method: 'PUT',
      url: 'shipper/delivery-address',
      data,
    };
  },
};
